/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinancialPlanAddDeferredIncomeRequestDto
 */
export interface FinancialPlanAddDeferredIncomeRequestDto {
  /**
   *
   * @type {string}
   * @memberof FinancialPlanAddDeferredIncomeRequestDto
   */
  deferredIncomeId: string;
}

export function FinancialPlanAddDeferredIncomeRequestDtoFromJSON(json: any): FinancialPlanAddDeferredIncomeRequestDto {
  return FinancialPlanAddDeferredIncomeRequestDtoFromJSONTyped(json, false);
}

export function FinancialPlanAddDeferredIncomeRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanAddDeferredIncomeRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    deferredIncomeId: json["deferredIncomeId"],
  };
}

export function FinancialPlanAddDeferredIncomeRequestDtoToJSON(
  value?: FinancialPlanAddDeferredIncomeRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    deferredIncomeId: value.deferredIncomeId,
  };
}
